import Breadcrumb from '@/components/base/Breadcrumb';
import Countdown from '@/components/feature/Countdown';
import { PHASES } from '@/mocks/schedule';
import { formatCnDate } from '@/utils/date';

export default function ScheduleHero() {
  const activePhase = PHASES.find((p) => p.status === 'active');
  const facts = [
    { label: '赛程阶段', value: '7 个' },
    { label: '关键节点', value: '6 个' },
    { label: '当前阶段', value: activePhase ? activePhase.name : '已结束' },
    { label: '颁奖日期', value: formatCnDate('2026-11-30') },
  ];

  return (
    <section className="w-full px-4 md:px-6 pt-28 md:pt-36 pb-12 md:pb-16 bg-background-100">
      <div className="max-w-6xl mx-auto w-full">
        <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '赛程时间表' }]} />

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-7">
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              爆料大赛赛程时间表
            </h1>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
              完整的阶段划分与节点日历。海选、初审、初赛、复赛、半决赛、决赛到颁奖，每一个阶段的起止时间、需要做什么、什么时候出结果，都按顺序列在下面。
            </p>
            <p className="mt-3 text-xs md:text-sm text-foreground-500">页面时间均为北京时间（UTC+8），点击阶段筛选可快速定位当前进度。</p>
          </div>
          <div className="lg:col-span-5 w-full">
            <div className="rounded-lg bg-secondary-950 px-6 py-7 w-full">
              <Countdown tone="dark" />
            </div>
          </div>
        </div>

        <dl className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-px bg-background-200 rounded-md overflow-hidden border border-background-200">
          {facts.map((f) => (
            <div key={f.label} className="bg-background-50 px-4 md:px-6 py-5">
              <dt className="text-xs md:text-sm text-foreground-500">{f.label}</dt>
              <dd className="mt-2 font-heading text-lg md:text-xl font-bold text-foreground-950">{f.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}